const { tenantSearchSmsPayload } = require('./tenantSearchSms');

const EMAIL_FOOTER = [
  '<br><br>Regards,<br>**The Pixie Properties Team**<br>616-344-0214 - Text or Call<br><br>',
  '<small>If you are no longer a tenant of Pixie Properties please disregard this email and reply so that we can remove you from future mailings.</small>',
].join('');

function personName(person) {
  const named = String((person && person.fullName) || '').trim();
  if (named) return named;
  return `${(person && person.First) || ''} ${(person && person.Last) || ''}`.trim();
}

function stripMarkdown(value) {
  let text = String(value || '');
  text = text.replace(/!\[[^\]]*\]\([^)]*\)/g, '');
  text = text.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
  text = text.replace(/```[\s\S]*?```/g, (block) => block.replace(/```/g, ''));
  text = text.replace(/`([^`]+)`/g, '$1');
  text = text.replace(/^#{1,6}[ \t]+/gm, '');
  text = text.replace(/(\*\*|__)(.*?)\1/g, '$2');
  text = text.replace(/(\*|_)(.*?)\1/g, '$2');
  text = text.replace(/^[ \t]*[-*+][ \t]+/gm, '');
  text = text.replace(/^[ \t]*\d+\.[ \t]+/gm, '');
  text = text.replace(/<[^>]+>/g, '');
  return text.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}

function broadcastEmailHtml(markdown, render) {
  const body = String(markdown || '').replace(/\s+$/, '');
  const source = body ? `${body}\n\n${EMAIL_FOOTER}` : EMAIL_FOOTER;
  return render(source);
}

function broadcastEmailSubject(markdown) {
  const line = stripMarkdown(markdown).split('\n').map((part) => part.trim()).find(Boolean);
  if (!line) return 'Message from Pixie Properties';
  return line.length > 80 ? `${line.slice(0, 77)}...` : line;
}

function buildingAddress(building) {
  return String((building && (building.address || building.label)) || '').trim();
}

function buildingId(building) {
  return Number(building && (building.propertyId || building.Id));
}

function isSingleFamilyHome(building) {
  if (!building || Number(building.isParentAddr) === 1) return false;
  const id = buildingId(building);
  const parentId = Number(building.parentId);
  const unit = String(building.UnitNumber || '').trim().toLowerCase();
  return unit === 'house' && id > 0 && parentId === id;
}

function broadcastListAddress(building) {
  const address = buildingAddress(building);
  if (!isSingleFamilyHome(building)) return address;
  return address.replace(/\s+Apt\s+House\s*$/i, ' House').trim();
}

function filterBuildings(buildings, query) {
  const needle = String(query || '').trim().toLowerCase();
  const choices = (buildings || [])
    .filter(
      (building) =>
        Number(building && building.isParentAddr) === 1 ||
        isSingleFamilyHome(building),
    )
    .map((building) => {
      const address = broadcastListAddress(building);
      if (address === buildingAddress(building)) return building;
      return { ...building, address };
    });
  if (!needle) return choices;
  return choices.filter((building) =>
    buildingAddress(building).toLowerCase().includes(needle),
  );
}

function buildingChoiceLabel(address, selected, recipientCount) {
  const name = String(address || '').trim();
  if (!selected) return name;
  const count = Number(recipientCount);
  return `${name} (${Number.isFinite(count) ? count : 0})`;
}

function currentTenantsForBuildings(people, buildingIds) {
  const ids = new Set(
    (buildingIds || []).map((id) => Number(id)).filter((id) => id > 0),
  );
  const seen = new Set();
  const tenants = [];
  for (const person of people || []) {
    if (Number(person && person.active) !== 1) continue;
    if (!ids.has(Number(person.parentId))) continue;
    const id = Number(person.id);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    tenants.push(person);
  }
  return tenants;
}

function broadcastJobs(people) {
  const jobs = [];
  for (const person of people || []) {
    const name = personName(person) || 'Tenant';
    const peopleId = Number(person.id);
    if (!peopleId) continue;
    jobs.push({ channel: 'app', name, peopleId, person });
    if (Number(person.smsOptIn) === 1) {
      const plan = tenantSearchSmsPayload(person, 'message');
      if (plan.ok) jobs.push({ channel: 'sms', name, peopleId, person });
    }
    const email = String(person.SendEmail || person.sendEmail || '').trim();
    if (email && !email.toLowerCase().endsWith('@noemail.com')) {
      jobs.push({ channel: 'email', name, peopleId, person, email });
    }
  }
  return jobs;
}

function broadcastProgress(done, total) {
  const count = Number(total);
  if (!count) return 0;
  return Math.min(100, Math.round((Number(done) / count) * 100));
}

module.exports = {
  stripMarkdown,
  broadcastEmailHtml,
  broadcastEmailSubject,
  filterBuildings,
  buildingChoiceLabel,
  currentTenantsForBuildings,
  broadcastJobs,
  broadcastProgress,
};
